import React from 'react'
import { Paragraph, TitleParagraph } from '../../../components/text'
import astronot from '../../../static/images/about/animation/astronot.webp'
import waveLeft from '../../../static/images/about/animation/wave-left.webp'

import { Grid, Row, Col } from 'react-flexbox-grid'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

const AboutCreativeStyle = styled.div`
  margin-top: 100px;
  @media screen and (min-width: 300px) and (max-width: 1023px) {
    margin-top: 0;
  }
  position: relative;
  height: 410px;
  @media screen and (min-width: 300px) and (max-width: 1023px) {
    height: unset;
  }
  .wave-left {
    position: absolute;
    bottom: 70px;
    left: 0;
    width: 355px;
  }

  .image-astronot {
    position: absolute;
    left: 0;
    width: 450px;
    top: 90px;
  }
  img {
    width: 100%;
    display: block;
  }

  @media screen and (min-width: 300px) and (max-width: 1023px) {
    .width-100 {
      width: 100%;
      flex-basis: unset;
      max-width: 100%;
    }

    .image-astronot {
      position: relative;
      width: 100%;
      top: unset;
      margin-top: 50px;
    }

    .wave-left {
      display: none;
    }
  }
`

const AboutCreative = () => {
  const { t } = useTranslation()
  return (
    <AboutCreativeStyle>
      <div className="wave-left">
        <img src={waveLeft} alt="" />
      </div>
      <Grid>
        <Row>
          <Col lg={6} md={12} sm={12} xs={12} className="width-100">
            <div style={{ position: 'relative' }}>
              <div className="image-astronot">
                <img
                  style={{ width: '100%', display: 'block' }}
                  src={astronot}
                  alt=""
                />
              </div>
            </div>
          </Col>
          <Col lg={6} md={12} sm={12} xs={12}>
            <div style={{ marginTop: 40 }} className="">
              <TitleParagraph display="block" align="left">
                {t('pageAbout.part4')}
              </TitleParagraph>
              <div style={{ marginTop: 16 }}>
                <Paragraph>{t('pageAbout.part5')}</Paragraph>
              </div>
            </div>
          </Col>
        </Row>
      </Grid>
    </AboutCreativeStyle>
  )
}

export default AboutCreative
